import { faArrowUpRightFromSquare, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Klikkbart "dokument-kort" til min-side. Brukes til PDF-lenker
// (5-punkts ordre, øvingsdirektiv, sambandsplan, etc.).
// Åpner alltid i ny fane med target="_blank".
//
// Tre-kolonne layout: PDF-ikon | tittel/beskrivelse/meta | "ny fane"-ikon
function DocumentLink({ title, description, href, meta }) {
    return (
        <a className="document-link" href={href} target="_blank" rel="noopener noreferrer">
            <span className="document-link__icon" aria-hidden="true">
                <FontAwesomeIcon icon={faFilePdf} />
            </span>
            <span className="document-link__body">
                <span className="document-link__title">{title}</span>
                {description && <span className="document-link__desc">{description}</span>}
                {meta && <span className="document-link__meta">{meta}</span>}
            </span>
            <FontAwesomeIcon
                icon={faArrowUpRightFromSquare}
                className="document-link__external"
                aria-hidden="true"
            />
        </a>
    );
}

export default DocumentLink;
